/* Enhances native controls; never changes product records or creates a replacement form. */
(() => {
  'use strict';
  function initialise(scope) {
    scope.querySelectorAll('[data-cb-round-wok-data]').forEach(dataElement => {
      if (dataElement.dataset.ready) return;
      const section = dataElement.closest('.js-product');
      const info = section && section.querySelector('.product-info');
      const form = info && info.querySelector('.js-product-form-main');
      if (!form) return;
      let data;
      try { data = JSON.parse(dataElement.textContent); } catch { return; }
      if (!Array.isArray(data.variants) || !data.copy) return;
      const first = info.querySelector('.product-price');
      const last = form.closest('.product-info__block');
      if (!first || !last || first.parentElement !== info || last.parentElement !== info) return;
      const stock = info.querySelector('[data-cb-round-wok-stock]');
      const stockTitle = info.querySelector('[data-cb-round-wok-stock-title]');
      const stockDetail = info.querySelector('[data-cb-round-wok-stock-detail]');
      const heading = info.querySelector('[data-cb-round-wok-delivery-heading]');
      const detail = info.querySelector('[data-cb-round-wok-delivery-detail]');
      const estimate = info.querySelector('[data-cb-round-wok-delivery-estimate]');
      if (!stock || !stockTitle || !stockDetail || !heading || !detail || !estimate) return;
      const nodes = [];
      for (let node = first; node; node = node.nextSibling) { nodes.push(node); if (node === last) break; }
      if (nodes[nodes.length - 1] !== last) return;
      const copy = data.copy;
      const panel = document.createElement('section');
      panel.className = 'cb-round-wok-panel';
      panel.setAttribute('aria-label', copy.panel);
      info.insertBefore(panel, first);
      nodes.forEach(node => panel.appendChild(node));
      dataElement.dataset.ready = 'true';
      const label = form.querySelector('quantity-input label, label[for^="quantity-"]');
      if (label) { label.textContent = copy.quantity; label.classList.remove('visually-hidden'); }
      const quantity = form.querySelector('[name="quantity"]');
      if (quantity) quantity.setAttribute('aria-label', copy.quantity);
      let selected = data.variants.find(item => String(item.id) === String(data.selectedId));
      const inStock = () => selected && selected.available && selected.tracked && selected.stock > 0;
      function updateDelivery() {
        let message = { headline: selected && selected.available ? copy.contact_delivery : copy.unavailable, detail: selected && selected.available ? copy.stock_dependent : copy.contact_team, estimate: '' };
        if (inStock()) {
          message = { headline: copy.cutoff, detail: copy.working_days, estimate: '' };
          const calendar = window.CBNaturalPurchaseUtils;
          if (calendar && typeof calendar.delivery === 'function') { try { message = calendar.delivery(new Date()); } catch {} }
        }
        heading.textContent = message.headline; detail.textContent = message.detail; estimate.textContent = message.estimate;
      }
      function updateState(variant) {
        selected = variant;
        const available = selected && selected.available;
        stock.dataset.state = inStock() ? 'stock' : available ? 'order' : 'sold-out';
        stockTitle.textContent = inStock() ? copy.in_stock : available ? copy.available : copy.sold_out;
        stockDetail.textContent = inStock() ? copy.ready : copy.check;
        updateDelivery();
      }
      section.addEventListener('on:variant:change', event => { const variant = event.detail && event.detail.variant; updateState(data.variants.find(item => variant && String(item.id) === String(variant.id))); });
      updateState(selected);
      function tick() { if (!section.isConnected) return; updateDelivery(); window.setTimeout(tick, 1000); }
      window.setTimeout(tick, 1000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
